var _g;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIslamic = function SvgIslamic(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#3B3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.314 6.311a.489.489 0 0 1 .872 0L20.2 8.352a.483.483 0 0 0 .366.263l2.271.329a.477.477 0 0 1 .27.814l-1.65 1.6a.475.475 0 0 0-.138.421l.389 2.255a.484.484 0 0 1-.7.5l-2.024-1.059a.492.492 0 0 0-.454 0l-2.03 1.061a.484.484 0 0 1-.7-.5l.389-2.255a.475.475 0 0 0-.138-.421l-1.65-1.6a.477.477 0 0 1 .27-.814l2.271-.329a.483.483 0 0 0 .366-.263l1.006-2.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.043c0-3.818 2.945-8.4 7.838-8.959a.751.751 0 0 0 .2-1.438 11.249 11.249 0 1 0-.003 20.796.751.751 0 0 0-.2-1.439 9.142 9.142 0 0 1-7.835-8.96z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIslamic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/islamic.f02aa3e8.svg";
export { ForwardRef as ReactComponent };